import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { listSessions, type PersistentSession } from "./api";

// Store the facilitator token so the dashboard can authorize control actions.
export function saveFacilitatorToken(sessionId: string, token: string) {
  localStorage.setItem(`fac:${sessionId}`, token);
}
export function getFacilitatorToken(sessionId: string): string {
  return localStorage.getItem(`fac:${sessionId}`) || "";
}

export function Landing() {
  const nav = useNavigate();
  const [code, setCode] = useState("");

  // Persistent Live / Sandbox sessions for the start-screen dropdown.
  const [sessions, setSessions] = useState<PersistentSession[]>([]);
  const [pickId, setPickId] = useState("");

  useEffect(() => {
    listSessions()
      .then((s) => {
        setSessions(s);
        setPickId((cur) => cur || s[0]?.id || "");
      })
      .catch(() => {});
  }, []);

  const picked = sessions.find((s) => s.id === pickId);

  const field: React.CSSProperties = {
    width: "100%",
    padding: "10px 12px",
    border: "1.5px solid var(--border)",
    borderRadius: "var(--radius-sm)",
    fontSize: 13,
    color: "var(--fg-inv)",
    background: "var(--surface)",
    fontFamily: "var(--font)",
  };

  return (
    <div className="center-screen">
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <img src="/brand/ey-mark.svg" alt="EY" style={{ height: 40 }} />
        <span style={{ color: "var(--muted)", fontWeight: 300, fontSize: 22 }}>×</span>
        <img src="/brand/microsoft-white.svg" alt="Microsoft" style={{ height: 22 }} />
      </div>
      <h1>Workforce AI Readiness</h1>
      <p>Enter the live session to capture responses, or open the sandbox to explore the dashboard.</p>

      <div
        style={{
          background: "var(--surface)",
          borderRadius: "var(--radius-lg)",
          padding: 28,
          width: 440,
          maxWidth: "90vw",
          display: "flex",
          flexDirection: "column",
          gap: 14,
          textAlign: "left",
          marginTop: 8,
        }}
      >
        <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", color: "var(--violet)" }}>
          Open a session
        </div>
        <label style={{ fontSize: 12, color: "var(--muted)", fontWeight: 600 }}>
          Choose session
          <select
            style={{ ...field, marginTop: 4, appearance: "auto" }}
            value={pickId}
            onChange={(e) => setPickId(e.target.value)}
            disabled={!sessions.length}
          >
            {sessions.length ? (
              sessions.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.kind === "sandbox" ? "Sandbox — explore & practice" : "Live Session — capture responses"}
                </option>
              ))
            ) : (
              <option>Loading…</option>
            )}
          </select>
        </label>
        <button
          className="btn-primary"
          onClick={() => pickId && nav(`/s/${pickId}`)}
          disabled={!pickId}
        >
          {picked?.kind === "sandbox" ? "Open sandbox →" : "Enter live session →"}
        </button>

        <div style={{ borderTop: "1px solid var(--border)", margin: "6px 0", paddingTop: 14 }}>
          <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", color: "var(--muted)", marginBottom: 8 }}>
            Join as participant
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <input
              style={{ ...field, fontFamily: "var(--font-mono)", letterSpacing: "0.2em" }}
              placeholder="Code"
              value={code}
              maxLength={4}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
            />
            <button
              className="btn-primary"
              style={{ background: "var(--ms-blue)", whiteSpace: "nowrap" }}
              onClick={() => code && nav(`/join/${code}`)}
            >
              Join
            </button>
          </div>
        </div>
      </div>

      <Link
        to="/admin"
        style={{ marginTop: 18, fontSize: 12, color: "var(--muted)", textDecoration: "none", opacity: 0.7 }}
      >
        Admin
      </Link>
    </div>
  );
}
